import axios from 'axios';
import { API_URL } from '../config';

const instance = axios.create({
  baseURL: API_URL + '/v1/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  timeout: 3000,
});

export const handleError = (message: string, data: any, status: number) => {
  return Promise.reject({ message, data, status });
};

instance.interceptors.response.use(
  response => response,
  error => {
    if (error && error.response && error.response.status) {
      if (error.response.status === 401) {
        localStorage.removeItem('isAuth');
        window.location.href = '/login';
      } else if (error.response.status === 403) {
        localStorage.removeItem('isAuth');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
